// extracted by mini-css-extract-plugin
export default {"title":"Q7KLIv","info":"SG_fmw"};